"use client";

import { css, cx } from "styled-system/css";
import { useEffect, useState } from "react";
import { cf } from "@/components/brand/sfturnos-styles";

type Row = { id: string; title: string; body: string };

export function DashboardAnnouncements() {
  const [items, setItems] = useState<Row[]>([]);

  useEffect(() => {
    void fetch("/api/public/announcements?for=dashboard", { credentials: "include" })
      .then((r) => r.json())
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <div className={css({ display: "flex", flexDir: "column", gap: "3", mb: "8" })}>
      {items.map((n) => (
        <div
          key={n.id}
          className={cx(
            cf.dashSurface,
            css({
              p: "5",
              borderLeftWidth: "4px",
              borderLeftColor: "#6366f1",
              bg: "linear-gradient(135deg, #eef2ff 0%, #ffffff 100%)",
            }),
          )}
        >
          <p className={css({ fontSize: "xs", fontWeight: "bold", letterSpacing: "wider", color: "#4f46e5", mb: "1" })}>
            Aviso de SFTURNOS
          </p>
          <p className={css({ fontWeight: "semibold", color: "#0f172a" })}>{n.title}</p>
          <p className={css({ fontSize: "sm", color: "#475569", mt: "2", whiteSpace: "pre-wrap", lineHeight: "1.5" })}>
            {n.body}
          </p>
        </div>
      ))}
    </div>
  );
}
